import React from "react";
import { ViewAsToggle } from "./components/ViewAsToggle";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import CoachDashboard from "./pages/CoachDashboard";
import TrendingPage from "./pages/TrendingPage";
import PlayerDetail from "./pages/PlayerDetail";
import ComparePage from "./pages/ComparePage";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import UsersPage from "./pages/UsersPage";
import MemberDetail from "./pages/MemberDetail";
import OrganizationsPage from "./pages/OrganizationsPage";
import SynergyDemoPage from "./pages/SynergyDemoPage";
import MyPlayers from "./pages/MyPlayers";
import PlayerHome from "./pages/PlayerHome";
import TacticalIQList from "./pages/TacticalIQList";
import LibraryHome from "./pages/LibraryHome";
import FilmDatabase from "./pages/FilmDatabase";
import RoutineLibrary from "./pages/RoutineLibrary";
import WeeklyWins from "./pages/WeeklyWins";
import TacticalIQPage from "./pages/TacticalIQPage";
import LegalPage from "./pages/LegalPage";
import PublicReport from "./pages/PublicReport";
import CoachInputPage from "./pages/CoachInputPage";
import LandingPage from "./pages/LandingPage";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ViewAsToggle />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
            <Route path="/report/:token" element={<PublicReport />} />
            <Route path="/coach-input/:token" element={<CoachInputPage />} />
            <Route path="/terms" element={<LegalPage kind="terms" />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="/coach" element={<ProtectedRoute><CoachDashboard /></ProtectedRoute>} />
            <Route path="/trending" element={<ProtectedRoute><TrendingPage /></ProtectedRoute>} />
            <Route path="/player/:id" element={<ProtectedRoute><PlayerDetail /></ProtectedRoute>} />
            <Route path="/compare" element={<ProtectedRoute><ComparePage /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute adminOnly><UsersPage /></ProtectedRoute>} />
            <Route path="/members/:userId" element={<ProtectedRoute adminOnly><MemberDetail /></ProtectedRoute>} />
            <Route path="/orgs" element={<ProtectedRoute adminOnly><OrganizationsPage /></ProtectedRoute>} />
            <Route path="/synergy-demo" element={<ProtectedRoute adminOnly><SynergyDemoPage /></ProtectedRoute>} />
            <Route path="/my-players" element={<ProtectedRoute familyAllowed><MyPlayers /></ProtectedRoute>} />
            <Route path="/home/:id" element={<ProtectedRoute familyAllowed><PlayerHome /></ProtectedRoute>} />
            <Route path="/library" element={<ProtectedRoute><LibraryHome /></ProtectedRoute>} />
            <Route path="/tactical-iq" element={<ProtectedRoute><TacticalIQList /></ProtectedRoute>} />
            <Route path="/tactical-iq/:slug" element={<ProtectedRoute><TacticalIQPage /></ProtectedRoute>} />
            <Route path="/technical-skill" element={<ProtectedRoute><TacticalIQList section="technical" /></ProtectedRoute>} />
            <Route path="/technical-skill/:slug" element={<ProtectedRoute><TacticalIQPage section="technical" /></ProtectedRoute>} />
            <Route path="/player-archetypes" element={<ProtectedRoute><TacticalIQList section="archetype" /></ProtectedRoute>} />
            <Route path="/player-archetypes/:slug" element={<ProtectedRoute><TacticalIQPage section="archetype" /></ProtectedRoute>} />
            <Route path="/physical-tools" element={<ProtectedRoute><TacticalIQList section="physical" /></ProtectedRoute>} />
            <Route path="/physical-tools/:slug" element={<ProtectedRoute><TacticalIQPage section="physical" /></ProtectedRoute>} />
            <Route path="/character-dna" element={<ProtectedRoute><TacticalIQList section="character" /></ProtectedRoute>} />
            <Route path="/character-dna/:slug" element={<ProtectedRoute><TacticalIQPage section="character" /></ProtectedRoute>} />
            <Route path="/film-database" element={<ProtectedRoute><FilmDatabase /></ProtectedRoute>} />
            <Route path="/routine-library" element={<ProtectedRoute><RoutineLibrary /></ProtectedRoute>} />
            <Route path="/weekly-wins" element={<ProtectedRoute><WeeklyWins /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}
